"use client";

import Button from "react-bootstrap/Button";

import "../styles/result-card-grid.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { useFullScreen } from "../contexts/FullScreenProvider";

export const CardSkillsInfo = ({ skills }) => {
  const { isFullScreen } = useFullScreen();
  if (!skills || skills.length === 0) {
    return (
      <div className="info-item d-flex align-items-center mb-2">
        <i
          className="fas fa-graduation-cap mr-2"
          style={{ fontSize: "12px" }}
        />
        <span
          className="info-text"
          style={{ fontSize: "0.85rem", color: "#495057" }}
        >
          N/A
        </span>
      </div>
    );
  }

  return (
    <div className="info-item d-flex align-items-center mb-2">
      <i
        className="fas fa-thumbs-up mr-2"
        style={{ fontSize: "12px", marginBottom: "auto", paddingTop: "4px" }}
      />
      <div
        className="info-text d-flex flex-column"
        style={{ fontSize: "0.85rem", color: "#495057" }}
      >
        <p style={{ marginBottom: "0" }}>{skills[0].name}</p>
        <div>
          {skills.length > 1 && (
            <OverlayTrigger
              trigger={["click", "hover", "focus"]}
              placement="auto"
              rootClose
              overlay={
                <Popover
                  id="education-popover"
                  className={isFullScreen ? "popover-fullscreen" : ""}
                >
                  <Popover.Title as="h3">
                    <i className="fa fa-thumbs-up mr-2" />
                    Other Skills
                  </Popover.Title>
                  <Popover.Content>
                    <ul style={{ paddingLeft: 18, margin: 0 }}>
                      {skills.slice(1).map((skill, idx) => (
                        <li key={skill.id || idx}>{skill.name}</li>
                      ))}
                    </ul>
                  </Popover.Content>
                </Popover>
              }
            >
              <Button
                variant="link"
                size="sm"
                className="p-0 ms-2"
                style={{
                  fontSize: "0.8em",
                  color: "#17a2b8",
                  textDecoration: "underline",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                }}
              >
                View {skills.length - 1} more
              </Button>
            </OverlayTrigger>
          )}
        </div>
      </div>
    </div>
  );
};
